import React from 'react'
import './subject.css'

class TextSubject extends React.Component {
    constructor(props) {
        super(props)
    }
    render() {
        return (
            <div className="subject-single-choice">
                <div className="subject-entry">

                    <div class='checkbox'>
                        <input type='checkbox' id={'checkbox' + this.props.id} name='checkboox[]'></input>
                        <label for={'checkbox' + this.props.id}></label>
                    </div>
                    <p className="subject-entry-word">{this.props.id}.文本题</p>
                    <textarea className="subject-entry-input subject-text-title" placeholder="题目内容"></textarea>
                </div>
                <div className="subject-aline"></div>
            </div>
        );
    }
}

export default TextSubject;